module.exports = __webpack_public_path__ + "img/lamp-control.2d5ef4e6.png";